import { useI18nContext } from "@/i18n/i18n-solid"
import { disclaimerLink, disclaimerText } from "./privacy-disclaimer.css"

const PUBLIC_URL = import.meta.env.VITE_FIKA_PUBLIC_URL

export function PrivacyDisclaimer() {
  const { LL } = useI18nContext()

  return (
    <div class={disclaimerText}>
      {LL().auth.disclaimerPrefix()}{" "}
      <a
        class={disclaimerLink}
        href={`${PUBLIC_URL}/privacy-policy`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {LL().auth.disclaimerPrivacy()}
      </a>{" "}
      {LL().auth.disclaimerAnd()}{" "}
      <a
        class={disclaimerLink}
        href={`${PUBLIC_URL}/terms-of-use`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {LL().auth.disclaimerTerms()}
      </a>
      .
    </div>
  )
}
